import React from 'react';
import UIStrings from '@/Utils/UIStrings';
import CustomBox from './Common/CustomBox';
import { HorizontalDivider } from './Common/CustomDivider';
import DetailsHeader from './Common/DetailsHeader';
import GridRowItem from './Common/GridRowItem';
import toDateString, { toUTCDate } from '@/Utils/DateHelper';

interface RecruitmentInformationSectionProps {
    completedAt?: string;
    locale: string | null;
}

function TestInformationSection({ completedAt, locale }: RecruitmentInformationSectionProps): React.JSX.Element {
    const formattedDate = completedAt === undefined ? '' : toDateString(toUTCDate(completedAt));

    return (
        <>
            <DetailsHeader label={UIStrings.TestInformation} />
            <HorizontalDivider />
            <CustomBox>
                <div className="flex flex-col gap-4">
                    <GridRowItem title={UIStrings.TestsCompleted} value={formattedDate} />
                    <GridRowItem title={UIStrings.TestsLanguage} value={locale ?? ''} />
                </div>
            </CustomBox>
        </>
    );
}
export default TestInformationSection;
